import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:chart-box-outline',
      order: 30,
      title: '绩效',
    },
    name: 'AdPerformance',
    path: '/performance',
    redirect: '/indicator-description',
    children: [
      {
        name: 'AdIndicatorDescription',
        path: '/indicator-description',
        component: () =>
          import('#/views/performance/indicator-description/index.vue'),
        meta: {
          icon: 'mdi:information-outline',
          title: '绩效指标说明',
          keepAlive: true,
        },
      },
      {
        name: 'AdConfig',
        path: '/config',
        component: () => import('#/views/performance/config/index.vue'),
        meta: {
          icon: 'mdi:tune-variant',
          title: '绩效配置',
          keepAlive: true,
        },
      },
      {
        name: 'AdAllMembers',
        path: '/all-members',
        component: () => import('#/views/performance/all-members/index.vue'),
        meta: {
          icon: 'mdi:account-group-outline',
          title: '全员绩效查看',
          keepAlive: true,
        },
      },
      {
        name: 'AdMine',
        path: '/mine',
        component: () => import('#/views/performance/mine/index.vue'),
        meta: {
          icon: 'mdi:account-outline',
          title: '我的绩效',
          keepAlive: true,
        },
      },
      {
        name: 'AdOperationLog',
        path: '/operation-log',
        component: () => import('#/views/performance/operation-log/index.vue'),
        meta: {
          icon: 'mdi:history',
          title: '绩效操作日志',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
